import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { ApiResponse, ObligationData, ObligationForm, ObligationListParams, Summary, UnObligatedAllotmentParams } from '../../data/system/obligation';

@Injectable()
export class ObligationService extends ObligationData {

  constructor(private http: HttpClient) { super(); }

  save(param: ObligationForm): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_save}`;
    return this.http.post<ApiResponse>(host, param).pipe(
      tap(data => console.log(`obligation->save->data`, data))
    );
  }

  nextSeries(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_next_series}`;
    return this.http.post<ApiResponse>(host, params).pipe(
      tap(data => console.log(`obligation->nextSeries->data`, data))
    );
  }

  get(year: string | number, campus: string | number, page: string | number, page_size: string | number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_get}`;
    return this.http.post<ApiResponse>(host, { year: year, campus: campus, page: page, page_size: page_size }).pipe(
      tap(data => console.log(`obligation->list->data`, data))
    );
  }

  getSummary(form: Summary | any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_summary}`;
    return this.http.post<ApiResponse>(host, form).pipe(
      tap(data => console.log(`obligation->summary->data`, data))
    );
  }

  delete(id: number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_delete.replace(":id", id)}`;
    return this.http.delete<ApiResponse>(host);
  }

  update(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_update}`;
    return this.http.post<ApiResponse>(host, params);
  }

  search(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_search}`;
    return this.http.post<ApiResponse>(host, params);
  }

  updateRemarks(params: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_cancel}`;
    return this.http.post<ApiResponse>(host, params);
  }

  restore(id: number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_restore.replace(":id", id)}`;
    return this.http.post<ApiResponse>(host, {});
  }

  getTotalItemAmount(id: number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_get_total_item_amount.replace(":id", id)}`;
    return this.http.get<ApiResponse>(host);
  }

  deleteStatus(id: number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_delete_status.replace(":id", id)}`;
    return this.http.delete<ApiResponse>(host);
  }

  deleteStatusDetails(id: number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_delete_status_details.replace(":id", id)}`;
    return this.http.delete<ApiResponse>(host);
  }

  getListSummary(params: ObligationListParams): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_list_summary}`;
    return this.http.post<ApiResponse>(host, params).pipe(
      tap(data => console.log(`obligation->ListSummary->data`, data))
    );
  }

  getUnObligatedAllotment(params: UnObligatedAllotmentParams): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.obligation_unobligated_allotment}`;
    return this.http.post<ApiResponse>(host, params);
  }

}